(() => {
  const dialog = document.getElementById('VfCartConfirmation');
  const selector = document.querySelector('[data-vf-cut-selector]');
  if (!dialog || !selector || typeof dialog.showModal !== 'function') return;
  const strings = JSON.parse(dialog.querySelector('[data-vf-confirm-strings]').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const checkout = dialog.querySelector('[data-vf-confirm-checkout]');
  const status = dialog.querySelector('[data-vf-confirm-status]');
  const title = document.getElementById('VfCartConfirmationTitle');
  const summary = dialog.querySelector('[data-vf-confirm-summary]');
  let returnFocus;
  let sequence = 0;
  let confirmation;

  const showStatus = (message) => {
    status.textContent = message || '';
    status.hidden = !message;
  };
  const weightsReady = (cart) => Array.isArray(cart?.items) && cart.items.length > 0 && cart.items.every((item) => {
    if (!item.properties?.['Requested cut length']) return true;
    const expected = Number(item.properties['_Estimated material weight grams']);
    const native = Number(item.grams);
    return Number.isFinite(expected) && Number.isFinite(native) && expected > 0 && native > 0 && Math.abs(expected - native) <= 5 && Number(item.original_price) > 0;
  });
  const readCart = async () => {
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(6000) });
    if (!response.ok) throw new Error('Cart unavailable');
    const cart = await response.json();
    if (!Array.isArray(cart.items)) throw new Error('Cart unavailable');
    return cart;
  };
  const matches = (item, added) => String(item.variant_id) === String(added.variantId)
    && item.properties?.['_Billet SKU'] === added.sku
    && item.properties?.['Requested cut length'] === added.length;

  const updateSummary = (cart) => {
    const subtotal = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cart.currency || 'USD' }).format(cart.total_price / 100);
    summary.textContent = (cart.item_count === 1 ? strings.one_item : strings.many_items).replace('[count]', String(cart.item_count)).replace('[subtotal]', subtotal);
  };

  const refreshCartUI = async (cart) => {
    const url = new URL(window.location.href);
    url.searchParams.set('sections', 'cart-icon-bubble,cart-drawer');
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(6000) });
    if (!response.ok) throw new Error('Cart display unavailable');
    const sections = await response.json();
    const parser = new DOMParser();
    const icon = document.getElementById('cart-icon-bubble');
    if (icon && sections['cart-icon-bubble']) {
      const section = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (section) icon.innerHTML = section.innerHTML;
    }
    const drawer = document.querySelector('cart-drawer');
    const source = sections['cart-drawer'] && parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
    const target = drawer?.querySelector('#CartDrawer');
    if (source && target) {
      target.innerHTML = source.innerHTML;
      drawer.classList.toggle('is-empty', cart.item_count === 0);
      target.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
    }
  };

  const restoreForm = (options) => {
    document.querySelectorAll('.input-file').forEach((input) => { if (input.prevName) input.name = input.prevName; });
    if (document.querySelector('[name="id_prev"]')) {
      document.querySelectorAll('[name="id"]').forEach((input) => input.remove());
      document.querySelectorAll('[name="id_prev"]').forEach((input) => { input.name = 'id'; });
    }
    document.querySelectorAll('#dpo-cart-properties, #dpo_tmp_form').forEach((element) => element.remove());
    selector.querySelectorAll('.submitting').forEach((element) => {
      element.classList.remove('submitting');
      element.querySelectorAll(':scope > *').forEach((child) => { child.style.opacity = ''; });
    });
    selector.querySelectorAll('[data-vf-submit]').forEach((button) => { button.removeAttribute('aria-disabled'); });
    if (options) options.prevAddToCartButton?.prop?.('disabled', false);
    selector.syncedVariantId = null;
    selector.update?.();
  };

  const confirm = async (added, data, options) => {
    const current = ++sequence;
    confirmation = added;
    restoreForm(options);
    returnFocus = selector.querySelector('[data-vf-submit]');
    checkout.disabled = true;
    title.textContent = data ? strings.title : strings.uncertain_title;
    dialog.querySelector('.vf-cart-confirmation__check').textContent = data ? '✓' : '!';
    dialog.querySelector('[data-vf-confirm-item]').textContent = strings.billet.replace('[sku]', added.sku) + '\n' + added.length;
    summary.textContent = '';
    showStatus(data ? strings.checking : strings.uncertain);
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('vf-confirm-open');
    dialog.querySelector('[data-vf-confirm-continue]').focus({ preventScroll: true });
    let cart;
    const deadline = Date.now() + 60000;
    for (let attempt = 0; attempt < 60 && Date.now() < deadline; attempt += 1) {
      try {
        cart = await readCart();
        if (current !== sequence) return;
        if (weightsReady(cart)) updateSummary(cart);
        if (cart.items.some((item) => matches(item, added)) && weightsReady(cart)) break;
      } catch {}
      if (attempt < 59) await new Promise((resolve) => setTimeout(resolve, 1000));
    }
    if (current !== sequence) return;
    if (cart) {
      try { await refreshCartUI(cart); } catch {}
    }
    if (current !== sequence) return;
    const ready = data && cart?.items.some((item) => matches(item, added)) && weightsReady(cart);
    checkout.disabled = !ready;
    if (ready) updateSummary(cart);
    showStatus(ready ? '' : data ? strings.review : strings.uncertain);
  };

  document.addEventListener('vf:cart-ready', (event) => {
    const cart = event.detail;
    if (!confirmation || !weightsReady(cart) || !cart.items.some((item) => matches(item, confirmation))) return;
    updateSummary(cart);
    checkout.disabled = false;
    showStatus('');
  });

  const close = () => dialog.close();
  dialog.querySelector('[data-vf-confirm-close]').addEventListener('click', close);
  dialog.querySelector('[data-vf-confirm-continue]').addEventListener('click', close);
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('vf-confirm-open');
    returnFocus?.focus({ preventScroll: true });
  });
  checkout.addEventListener('click', async () => {
    checkout.disabled = true;
    showStatus(strings.checking);
    try {
      const cart = await readCart();
      if (!cart.item_count) { showStatus(strings.empty); return; }
      if (!weightsReady(cart) || !cart.items.some((item) => matches(item, confirmation))) { showStatus(strings.review); return; }
      window.location.assign(root + 'checkout');
    } catch { showStatus(strings.review); }
    finally { checkout.disabled = false; }
  });

  const bind = (attempt = 0) => {
    if (!window.jQuery) {
      if (attempt < 100) window.setTimeout(() => bind(attempt + 1), 200);
      return;
    }
    window.jQuery(window).off('dpo_before_form_submit.vfConfirmation').on('dpo_before_form_submit.vfConfirmation', (_event, temp) => {
      const form = temp?.tagName === 'FORM' ? temp : temp?.[0];
      if (form?.tagName !== 'FORM' || !selector.contains(document.querySelector('[data-vf-form]')) || Number(window.dpoObserver?.directAddToCartSubmit) !== 2) return;
      const formData = new FormData(form);
      const sku = formData.get('properties[_Billet SKU]');
      const length = formData.get('properties[Requested cut length]');
      if (!sku || !length) return;
      const options = window.dpoOptions;
      const previous = options.asyncAddToCartPostCheck;
      options.asyncAddToCartPostCheck = function (variantId, data) {
        options.asyncAddToCartPostCheck = previous;
        void confirm({ variantId, sku: String(sku), length: String(length) }, data, options);
      };
    });
  };
  bind();
})();

